/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { Typography } from "@mui/material";

type SchrittCountProps = {
    akutellerSchritt: number;
    schritteGesamt: number;
}

export default function SchrittCount(props: SchrittCountProps) {
    return (
        <Typography
            sx={{
                marginLeft: "auto",
                display: "grid",
                placeItems: "center",
                "&:first-child": {
                    transform: "translateX(150%)",
                },
            }}
            variant="body2"
            color="textSecondary"
        >
            {props.akutellerSchritt} / {props.schritteGesamt}
        </Typography>
    );
}